module.exports = __webpack_public_path__ + "images/pages/for_business/pc/case3_363ef66d2d6d8ece12bb149530bb2e9d.png";